var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { class: { grid: true, "grid--loading": _vm.$wait.is("members") } },
      [
        _vm.error
          ? _c("li", { staticClass: "grid__error col-12" }, [
              _c("span", { staticClass: "h2" }, [
                _vm._v("Unable to load members."),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--link",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.getMembers.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ])
          : _vm.members.length
          ? _vm._l(_vm.filteredMembers(_vm.members), function (member) {
              return _c(
                "li",
                { staticClass: "col-6 col-md-3" },
                [
                  _vm.selectable
                    ? _c(
                        "div",
                        { staticClass: "card card--toggle card--image" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected,
                                expression: "selected",
                              },
                            ],
                            attrs: {
                              id: `member-${member.id}`,
                              type: "checkbox",
                              hidden: "",
                            },
                            domProps: {
                              value: member.id,
                              checked: Array.isArray(_vm.selected)
                                ? _vm._i(_vm.selected, member.id) > -1
                                : _vm.selected,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = member.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selected = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selected = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selected = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: `member-${member.id}` } },
                            [
                              member.countries
                                ? _c(
                                    "span",
                                    { staticClass: "card__flags" },
                                    _vm._l(
                                      member.countries,
                                      function (country, index) {
                                        return _c("img", {
                                          directives: [
                                            {
                                              name: "tippy",
                                              rawName: "v-tippy",
                                              value: country.name,
                                              expression: "country.name",
                                            },
                                          ],
                                          key: index,
                                          attrs: { src: country.flag, alt: "" },
                                        })
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: `/images/logo/${member.id}`,
                                  alt: member.name,
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _c("MemberCard", {
                        attrs: { member: member, flags: true },
                      }),
                ],
                1
              )
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }